var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.625,
    height: 31.503,
    viewBox: "0 0 23.625 31.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "receipt",
    d: "M22.05.172,19.688,2.928,16.341.172a.978.978,0,0,0-1.181,0L11.813,2.928,8.466.172a.978.978,0,0,0-1.181,0L3.938,2.928,1.575.172A.984.984,0,0,0,0,.959V30.49a.984.984,0,0,0,1.575.787l2.363-2.756,3.347,2.756a.978.978,0,0,0,1.181,0l3.347-2.756,3.347,2.756a.978.978,0,0,0,1.181,0l3.347-2.756,2.362,2.756a.985.985,0,0,0,1.575-.787V.959A.984.984,0,0,0,22.05.172ZM19.688,22.123a.494.494,0,0,1-.492.492H4.43a.494.494,0,0,1-.492-.492v-.984a.494.494,0,0,1,.492-.492H19.2a.494.494,0,0,1,.492.492Zm0-5.906a.494.494,0,0,1-.492.492H4.43a.494.494,0,0,1-.492-.492v-.984a.494.494,0,0,1,.492-.492H19.2a.494.494,0,0,1,.492.492Zm0-5.906a.494.494,0,0,1-.492.492H4.43a.494.494,0,0,1-.492-.492V9.326a.494.494,0,0,1,.492-.492H19.2a.494.494,0,0,1,.492.492Z",
    transform: "translate(0 0.027)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.db7563677e945ed92a03fb666e2ac72a.svg";
export { ForwardRef as ReactComponent };